import { handleActions } from 'redux-actions';
import actions from '../actions/help';

const defaultState = {
  helpPageUrl: null,
};

const help = handleActions({
  [actions.setHelpPage]: (state, { payload: helpPageUrl }) => ({
    ...state,
    helpPageUrl,
  }),
}, defaultState);

export default help;



// WEBPACK FOOTER //
// ./src/state/reducers/help.js